const TIMELINE_STATUS = {
  PLANNED: { id: 0, name: "Planned" },
  ON_GOING: { id: 1, name: "On going" },
  COMPLETED: { id: 2, name: "Completed" },
};

export { TIMELINE_STATUS };
